export const arrangements = [
  {
    id: 'afterglow',
    no: '01',
    name: 'Afterglow',
    price: 86,
    note: 'Apricot roses, amber ranunculus and copper beech in a hand-thrown stoneware vessel.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/0a9d2030d78e6980171043cc5a230587/587ec097-3f6f-459e-9fda-bbab1d2fb4a2_ff-arr-afterglow.webp',
  },
  {
    id: 'field-notes',
    no: '02',
    name: 'Field Notes',
    price: 74,
    note: 'Wild grasses, scabiosa, chamomile and loose meadow stems in clear glass.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/0a9d2030d78e6980171043cc5a230587/587ec097-3f6f-459e-9fda-bbab1d2fb4a2_ff-arr-fieldnotes.webp',
  },
  {
    id: 'still-life-03',
    no: '03',
    name: 'Still Life No. 03',
    price: 98,
    note: 'Deep burgundy dahlias, black calla and plum foliage, low and asymmetric.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/0a9d2030d78e6980171043cc5a230587/587ec097-3f6f-459e-9fda-bbab1d2fb4a2_ff-arr-stilllife.webp',
  },
  {
    id: 'soft-geometry',
    no: '04',
    name: 'Soft Geometry',
    price: 92,
    note: 'White anthurium, green allium spheres and folded aspidistra in a sculpted vase.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/0a9d2030d78e6980171043cc5a230587/587ec097-3f6f-459e-9fda-bbab1d2fb4a2_ff-arr-softgeometry.webp',
  },
];